import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/**
 * A spinner component which will overlay on top of another component.
 */
@Component({
  selector: 'd-spinner-overlay',
  templateUrl: './d-spinner.component.html',
  styleUrls: ['./d-spinner.component.scss'],
  standalone: true,
  imports: [MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeightonSpinnerComponent {}
